import React, { useState, useRef, useEffect } from 'react';
// import PropTypes from 'prop-types';

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import 'lazysizes';

// Components
import { Menu } from '../../components/Extensivo/Menu';
import { Logo } from '../../components/Extensivo/Menu/Logo';
import { BoxMenuMobile } from '../../components/Extensivo/Menu/BoxMenuMobile';
import { BoxMenu } from '../../components/Extensivo/Menu/BoxMenu';
import { Link } from '../../components/Extensivo/Menu/Link';
import { Button } from '../../components/Extensivo/Button';
import { Card } from '../../components/Extensivo/Card';
import { H2 } from '../../components/Extensivo/Card/H2';
import { H3 } from '../../components/Extensivo/Card/H3';
import { H4 } from '../../components/Extensivo/Card/H4';
import { Courses } from '../../components/Extensivo/Card/Course';
// import { Message } from '../../components/Extensivo/Card/Message';
import { Price } from '../../components/Extensivo/Card/Price';
import { Paragraph } from '../../components/Extensivo/Card/Paragraph';
import { Separator } from '../../components/Extensivo/Card/Separator';
import { Image } from '../../components/Extensivo/Card/Image';
import { WarrantyLine } from '../../components/Extensivo/WarrantLine';
import { Modal } from '../../components/Extensivo/Modal';
// import Acordiao from '../../components/Extensivo/Acordiao';
import { Timeline } from '../../components/Extensivo/Timeline';
import { Testemonial } from '../../components/Extensivo/Testemonial';
import { BoxItem } from '../../components/Extensivo/Testemonial/BoxItem';
import { BoxVideo } from '../../components/Extensivo/Testemonial/BoxVideo';
import { BoxContent } from '../../components/Extensivo/Testemonial/BoxContent';
import { TestemonialH3 } from '../../components/Extensivo/Testemonial/H3';
import { TestemonialDescription } from '../../components/Extensivo/Testemonial/Description';
import { Banner } from '../../components/Vendas/Banner';
import { Faq } from '../../components/Extensivo/Faq';
import Loading from '../../components/Loading';
import AddressAndPolicies from '../../components/AddressAndPolicies';

// Services
import apiExtensivo from '../../services/Extensivo/api';

// import {Acordiao} from '../../components/Extensivo/acordiao';

// Assets

// import Extensivo from '../../assets/extensivo-sp-medway.svg';
import MenuIcon from '../../assets/menu-icon.png';
import CloseMenuIcon from '../../assets/close-menu-icon.png';
// import ImgTableMobile from '../../assets/Extensivo/tabela-extensivo-mobile.jpg';
// import logoIntensivoSP from '../../assets/logo-intensivo-sp.png';
// import extensivoBase from '../../assets/extensivo-base-medway.svg';
// import mentoria from '../../assets/logo-mentoria.png';
import Check from '../../assets/check-table.png';
import Error from '../../assets/error-table.png';
import extensivoProgramado from '../../assets/logo-extensivo-programado-2023.svg';

// Styles
import {
  Container,
  BoxHero,
  BoxComparison,
  BoxPillars,
  BoxWaranty,
  BoxBuy,
  BoxVideoTestemonial,
  BoxFaq,
  Footer,
} from './styles';

// Interface

interface Botao {
  title: string;
  url: string;
  target: string;
}

interface SubgrupoDuvidas {
  titulo_subgrupo: string;
  texto_subgrupo: string;
}

interface GrupoDuvidas {
  titulo_grupo: string;
  texto_grupo: string;
  subgrupo: [SubgrupoDuvidas];
}

interface Video {
  url_video: string;
  nome_video: string;
  aprovacao_video: string;
}

interface Ano {
  ano: string;
}

interface Comparison {
  titulo_coluna: string;
  icone_coluna: [
    {
      icone_curso: boolean;
    }
  ];
  botao_comparison: Botao;
}

interface CursosComparison {
  linha_curso: [
    {
      nome_curso: string;
    }
  ];
  coluna_curso: [Comparison];
}

interface Incluso {
  curso_incluso: string;
  valor_incluso: string;
}

interface BoxOptionsProps {
  bg: string;
  align: 'left' | 'center' | 'right';
}

interface ParagraphOptionsProps {
  align: 'left' | 'center' | 'right';
  bottom: string;
  top: string;
  size: string;
  width: string;
}
interface LogosProps {
  src_logo: {
    title: string;
    url: string;
  };
  alt?: string;
}
interface Data {
  logos: LogosProps[];
  startDate: string;
  endDate: string;
}

interface ExtraContent {
  logo_image: string;
  logo_alt_text: string;
  text_above_button: string;
  modal_text: string;
  button_text: string;
}

interface TimelineProps {
  timelineProps: {
    firstBoxOptions: BoxOptionsProps;
    firstTitle: string;
    yearTimeline: string;
    firstParagraphOptions: ParagraphOptionsProps;
    firstParagraph: string;
    dataCourseTimeline: Data;
    secondBoxOptions: BoxOptionsProps;
    secondParagraphOptions: ParagraphOptionsProps;
    secondParagraph: string;
    buttonOptions: Botao;
    secondTitle: string;
    ctaOptions: {
      modal_title: string;
      contents: [ExtraContent]
    };
  };
}

interface Dados {
  extensivo_prog: {
    hero: {
      status_hero: boolean;
      video_hero: string;
      titulo_hero: string;
      texto_hero: string;
      botao_hero: Botao;
    };

    pilar: {
      status_pilar: boolean;
      titulo_pilares: string;
      descricao_pilares: string;
      pilares: [
        {
          imagem_pilar: {
            title: string;
            url: string;
          };
          titulo_pilar: string;
          subtitulo_pilar: string;
          paragrafo_pilar: string;
          conteudo_pilar: string;
          botao_pilar: Botao;
        }
      ];
    };

    garantia: {
      status_garantia: boolean;
      titulo_garantia: string;
      subtitulo_garantia: string;
      data_garantia: string;
      texto_garantia: string;
    };

    sobre: {
      status_sobre: boolean;
      video_sobre: string;
      titulo: string;
    };

    valores: {
      status_valores: boolean;
      promocional_valores: boolean;
      titulo_valores: string;
      subtitulo_valores: string;
      incluso_valores: [Incluso];
      mensagem_valores: string;
      preco_anterior_valores: string;
      preco_valores: string;
      parcelas_valores: string;
      boleto_valores: string;
      botao_valores: Botao;
    };

    banner_alume: {
      status_banner: boolean;
      titulo_banner: string;
      subtitulo_banner: string;
      botao_banner: Botao;
    };

    depoimentos: {
      status_depoimentos: boolean;
      titulo_depoimentos: string;
      videos_depoimentos: [Video];
    };

    duvidas: {
      status_duvidas: boolean;
      titulo_duvidas: string;
      grupo_duvidas: [GrupoDuvidas];
    };

    comparacao: {
      status_comparison: boolean;
      titulo_comparison: string;
      descricao_comparison: string;
      cursos_comparison: {
        curso_linha: [CursosComparison];
      };
    };

    cursos: {
      status_cursos: boolean;
      ano_cursos: [Ano];
    };

    footer: {
      status_footer: boolean;
      titulo_footer: string;
      email_footer: Botao;
    };

    timeline: {
      status_timeline: boolean;
      boxRef: any;
      data_timeline: [TimelineProps];
    };
  };
}

const ExtensivoSP: React.FC = () => {
  const [statusModal, setStatusModal] = useState<boolean>(false);
  const [modalContent, setModalContent] = useState('');
  const [menuMobile, setMenuMobile] = useState(false);
  const [dados, setDados] = useState<Dados | null>(null);
  const hostName = window.location.hostname;
  const url_traffic_source = window.location.search;

  useEffect(() => {
    apiExtensivo
      .get(`pages/${hostName === 'extensivo.medway.com.br' ? `6127` : `8610`}`)
      .then(response => {
        setDados(response.data.acf);
      });
  }, []);

  // RefsToMenu
  const inscrevaBloco = useRef(null);
  const firstYear = useRef(null);
  const secondYear = useRef(null);
  const pilaresBloco = useRef(null);
  const garantiaBloco = useRef(null);
  const depoimentosBloco = useRef(null);
  const duvidasBloco = useRef(null);

  return (
    <>
      {dados ? (
        <>
          <Menu>
            <Logo src={extensivoProgramado} alt="Extensivo Medway" />
            <BoxMenuMobile
              onClick={() => {
                setMenuMobile(!menuMobile);
              }}
              src={menuMobile ? CloseMenuIcon : MenuIcon}
            />
            <BoxMenu menuMobile={menuMobile}>
              <Link
                href="https://medway.com.br"
                menuRef={inscrevaBloco}
                setMenuMobile={setMenuMobile}
                type="button"
              >
                O Extensivo
              </Link>
              <Link
                href="https://medway.com.br"
                menuRef={firstYear}
                setMenuMobile={setMenuMobile}
                type="button"
              >
                1º ano
              </Link>
              <Link
                href="https://medway.com.br"
                menuRef={secondYear}
                setMenuMobile={setMenuMobile}
                type="button"
              >
                2° ano
              </Link>
              <Link
                href="https://medway.com.br"
                menuRef={pilaresBloco}
                setMenuMobile={setMenuMobile}
                type="button"
              >
                Pilares
              </Link>
              <Link
                href="https://medway.com.br"
                menuRef={garantiaBloco}
                setMenuMobile={setMenuMobile}
                type="button"
              >
                Garantia
              </Link>
              <Link
                href="https://medway.com.br"
                menuRef={depoimentosBloco}
                setMenuMobile={setMenuMobile}
                type="button"
              >
                Depoimentos
              </Link>
              <Link
                href="https://medway.com.br"
                menuRef={duvidasBloco}
                setMenuMobile={setMenuMobile}
                type="button"
              >
                Dúvidas
              </Link>
              <Button fill="contained" size="small" pattern="base" href="#buy">
                Quero Comprar
              </Button>
            </BoxMenu>
          </Menu>

          {dados.extensivo_prog.hero.status_hero && (
            <BoxHero ref={inscrevaBloco}>
              <section className="callToAction">
                <div className="boxContent">
                  <div
                    className="title"
                    dangerouslySetInnerHTML={{
                      __html: dados.extensivo_prog.hero.titulo_hero,
                    }}
                  />

                  <div
                    className="text"
                    dangerouslySetInnerHTML={{
                      __html: dados.extensivo_prog.hero.texto_hero,
                    }}
                  />

                  {/* <p className="textSale">
                    Desconto de R$ 500 para as primeiras 500 compras!
                  </p> */}
                  <Button
                    fill="contained"
                    size="small"
                    pattern="base"
                    className="buttonHero"
                    href="#buy"
                    fluid
                  >
                    {dados.extensivo_prog.hero.botao_hero.title}
                  </Button>
                </div>
                <div
                  className="boxVideoHero"
                  dangerouslySetInnerHTML={{
                    __html: dados.extensivo_prog.hero.video_hero,
                  }}
                />
              </section>
            </BoxHero>
          )}

          {dados.extensivo_prog.timeline.status_timeline && (
            dados.extensivo_prog.timeline.data_timeline.map((item, key) => (
            <Timeline
              boxRef={key===0? firstYear : secondYear}
              data_timeline={dados.extensivo_prog.timeline.data_timeline[key]}
            />
            ))
          )}

          {dados.extensivo_prog.comparacao.status_comparison && (
            <BoxComparison>
              <Container>
                <div className="box-title">
                  <h2 className="title">
                    {dados.extensivo_prog.comparacao.titulo_comparison}
                  </h2>
                  <p className="text">
                    {dados.extensivo_prog.comparacao.descricao_comparison}
                  </p>
                </div>
                <div className="box-table-desktop">
                  <div className="table-head">
                    <div className="table-column"></div>
                    {dados.extensivo_prog.comparacao.cursos_comparison.curso_linha.map(
                      item =>
                        item.coluna_curso.map(i => (
                          <div className="table-column">
                            <h4 className="table-title">{i.titulo_coluna}</h4>
                          </div>
                        ))
                    )}
                  </div>
                  {dados.extensivo_prog.comparacao.cursos_comparison.curso_linha.map(
                    result => (
                      <div className="table-content">
                        <div className="table-column table-column__title">
                          {result.linha_curso.map(l => (
                            <div className="table-cell">
                              <h4 className="table-title">{l.nome_curso}</h4>
                            </div>
                          ))}
                          <div className="table-cell"></div>
                        </div>
                        {result.coluna_curso.map(c => (
                          <div className="table-column">
                            {c.icone_coluna.map(icon => (
                              <div className="table-cell">
                                <img
                                  className="lazyload table-icon"
                                  src=""
                                  data-srcset={`${
                                    icon.icone_curso === true ? Check : Error
                                  } 1x`}
                                  alt={
                                    icon.icone_curso === true
                                      ? 'Check'
                                      : 'Error'
                                  }
                                />
                              </div>
                            ))}
                            {c.botao_comparison.url && (
                              <div className="table-cell">
                                <Button
                                  fill="outlined"
                                  size="small"
                                  pattern="variant"
                                  fluid
                                  href={c.botao_comparison.url}
                                  target="_blanck"
                                >
                                  {c.botao_comparison.title}
                                </Button>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )
                  )}
                </div>
                {dados.extensivo_prog.comparacao.cursos_comparison.curso_linha.map(
                  result2 => (
                    <div className="box-table-mobile">
                      <div className="box-table-mobile__1">
                        <div className="table-head">
                          <div className="table-column"></div>
                        </div>
                        <div className="table-content">
                          <div className="table-column">
                            {result2.linha_curso.map(li => (
                              <div className="table-cell">
                                <h4 className="table-title">{li.nome_curso}</h4>
                              </div>
                            ))}
                            <div className="table-cell"></div>
                          </div>
                        </div>
                      </div>
                      <div className="box-table-mobile__2">
                        <OwlCarousel
                          className="owl-theme"
                          responsive={{
                            0: {
                              items: 1,
                              loop: true,
                              autoplay: true,
                              nav: false,
                            },
                          }}
                        >
                          {result2.coluna_curso.map(item2 => (
                            <div className="item">
                              <div className="table-head">
                                <div className="table-column">
                                  <h4 className="table-title">
                                    {item2.titulo_coluna}
                                  </h4>
                                </div>
                              </div>
                              <div className="table-content">
                                <div className="table-column">
                                  {item2.icone_coluna.map(co => (
                                    <div className="table-cell">
                                      <img
                                        className="lazyload table-icon"
                                        src=""
                                        data-srcset={`${
                                          co.icone_curso === true
                                            ? Check
                                            : Error
                                        } 1x`}
                                        alt={
                                          co.icone_curso === true
                                            ? 'Check'
                                            : 'Error'
                                        }
                                      />
                                    </div>
                                  ))}
                                  {item2.botao_comparison.url && (
                                    <div className="table-cell">
                                      <Button
                                        fill="outlined"
                                        size="small"
                                        pattern="variant"
                                        href={item2.botao_comparison.url}
                                        fluid
                                      >
                                        {item2.botao_comparison.title}
                                      </Button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </OwlCarousel>
                      </div>
                    </div>
                  )
                )}
              </Container>
            </BoxComparison>
          )}

          {dados.extensivo_prog.pilar.status_pilar && (
            <BoxPillars ref={pilaresBloco}>
              <div className="box-title">
                <h2 className="title">
                  {dados.extensivo_prog.pilar.titulo_pilares}
                </h2>
                <p className="description">
                  {dados.extensivo_prog.pilar.descricao_pilares}
                </p>
              </div>
              <div className="box-content">
                {dados.extensivo_prog.pilar.pilares.map((pilar, key) => (
                  <Card align="center" key={key}>
                    <Image
                      className="lazyload"
                      src=""
                      data-srcset={`${pilar.imagem_pilar.url} 1x`}
                      alt={pilar.imagem_pilar.title}
                    />
                    <H3 align="center">{pilar.titulo_pilar}</H3>
                    <H4 align="center">{pilar.subtitulo_pilar}</H4>
                    <Paragraph align="center" weight={400}>
                      {pilar.paragrafo_pilar}
                    </Paragraph>
                    <Separator />
                    <Button
                      onClick={() => {
                        setStatusModal(true);
                        setModalContent(pilar.conteudo_pilar);
                      }}
                      fill="outlined"
                      size="small"
                      pattern="base"
                    >
                      {pilar.botao_pilar.title}
                    </Button>
                  </Card>
                ))}
              </div>
            </BoxPillars>
          )}

          {dados.extensivo_prog.garantia.status_garantia && (
            <BoxWaranty ref={garantiaBloco}>
              <WarrantyLine
                title={dados.extensivo_prog.garantia.titulo_garantia}
                subtitle={dados.extensivo_prog.garantia.subtitulo_garantia}
                date={dados.extensivo_prog.garantia.data_garantia}
                text={dados.extensivo_prog.garantia.texto_garantia}
              />
            </BoxWaranty>
          )}

          {dados.extensivo_prog.depoimentos.status_depoimentos && (
            <BoxVideoTestemonial ref={depoimentosBloco}>
              <Container>
                <div className="box-title">
                  <h2 className="title">
                    {dados.extensivo_prog.depoimentos.titulo_depoimentos}
                  </h2>
                </div>
                <Testemonial nav dots loop={false}>
                  {dados.extensivo_prog.depoimentos.videos_depoimentos.map(
                    item => (
                      <BoxItem type="video">
                        <BoxVideo
                          dangerouslySetInnerHTML={{
                            __html: item.url_video,
                          }}
                        />
                        <BoxContent>
                          <TestemonialH3>{item.nome_video}</TestemonialH3>
                          <TestemonialDescription type="video">
                            {item.aprovacao_video}
                          </TestemonialDescription>
                        </BoxContent>
                      </BoxItem>
                    )
                  )}
                </Testemonial>
              </Container>
            </BoxVideoTestemonial>
          )}

          {dados.extensivo_prog.valores.status_valores && (
            <BoxBuy id="buy">
              <Card align="center" buy>
                <H2 align="center" buy>
                  {dados.extensivo_prog.valores.titulo_valores}
                </H2>
                <H4 align="center" buy>
                  {dados.extensivo_prog.valores.subtitulo_valores}
                </H4>
                {dados.extensivo_prog.valores.incluso_valores.map(item => (
                  <Courses course={item.curso_incluso} value={item.valor_incluso} />
                ))}
                {/* <Message type="sucess">
                  Desconto especial para as primeiras 500 vagas: R$500,00
                </Message> */}
                <Price type="old">
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        dados.extensivo_prog.valores.preco_anterior_valores,
                    }}
                  />
                </Price>
                <Price type="current">
                  {dados.extensivo_prog.valores.preco_valores}
                </Price>
                <Price type="instalments">
                  {dados.extensivo_prog.valores.parcelas_valores}
                </Price>
                <H4 align="center" buy>
                  {dados.extensivo_prog.valores.boleto_valores}
                </H4>
                <Button
                  href={`${dados.extensivo_prog.valores.botao_valores.url}${url_traffic_source}`}
                  fill="contained"
                  size="big"
                  pattern="base"
                  fluid
                >
                  {dados.extensivo_prog.valores.botao_valores.title}
                </Button>
              </Card>
            </BoxBuy>
          )}

          {dados.extensivo_prog.banner_alume.status_banner && (
            <Banner
              title={dados.extensivo_prog.banner_alume.titulo_banner}
              subtitle={dados.extensivo_prog.banner_alume.subtitulo_banner}
              button={dados.extensivo_prog.banner_alume.botao_banner}
            />
          )}

          {dados.extensivo_prog.duvidas.status_duvidas && (
            <BoxFaq ref={duvidasBloco}>
              <Faq
                title={dados.extensivo_prog.duvidas.titulo_duvidas}
                data={dados.extensivo_prog.duvidas.grupo_duvidas}
              />
            </BoxFaq>
          )}

          {dados.extensivo_prog.footer.status_footer && (
            <Footer>
              <div className="boxFooter">
                <p className="titleFooter">
                  {dados.extensivo_prog.footer.titulo_footer}{' '}
                  <a
                    className="mailto"
                    href={dados.extensivo_prog.footer.email_footer.url}
                  >
                    {dados.extensivo_prog.footer.email_footer.title}
                  </a>
                </p>
              </div>
              <AddressAndPolicies background = '' />
            </Footer>
          )}
          <Modal
            open={statusModal}
            setStatusModal={setStatusModal}
            modalContent={modalContent}
          />
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default ExtensivoSP;
